module.exports = __webpack_public_path__ + "img/leinster-rugby-logo-icon.c95ddb8c.png";